import { Box, Grid, TextField, Typography, useTheme } from "@mui/material";
import { Controller } from "react-hook-form";

import { DatePickerV1 } from "components";
import { inputFieldSx } from "../constants";
import PropTypes from "prop-types";

const FGBatchRow = ({
  control,
  index,
  disabled,
  disableFgReadyNow,
  remainingQty,
  isLastRow,
  originalBatchCount,
  hasPreDoId,
  today,
  maxAllowedDate,
  handleKeyDown,
  children,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 2, mt: 4 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={1.5}>
          <Controller
            name={`fgBatches.${index}.fgReadyNow`}
            control={control}
            render={({ field }) => (
              <TextField
                onKeyDown={handleKeyDown}
                {...field}
                fullWidth
                size="small"
                type="number"
                label="FG ready now (MT)"
                disabled={disableFgReadyNow || disabled}
                InputProps={{ inputProps: { min: 0, step: "any" } }}
                sx={{
                  ...inputFieldSx,
                  ...(index === 0 && {
                    "& .MuiOutlinedInput-root fieldset": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 1.5,
                    },
                  }),
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={1.7}>
          <Box sx={{ visibility: isLastRow ? "visible" : "hidden" }}>
            <Typography variant="body2">
              Remaining Qty : <strong>{remainingQty} MT</strong>
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={0.5}>
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: "primary.main" }}
          >
            FG{index + 1}
          </Typography>
        </Grid>

        <Grid item xs={12} md={1}>
          <Controller
            name={`fgBatches.${index}.qty`}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                type="number"
                label="Qty (MT)"
                disabled={disabled}
                onKeyDown={handleKeyDown}
                InputProps={{ inputProps: { min: 0, step: "any" } }}
                sx={inputFieldSx}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={1.8}>
          <Controller
            name={`fgBatches.${index}.readinessDate`}
            control={control}
            render={({ field }) => (
              <DatePickerV1
                value={field.value}
                onChange={field.onChange}
                label="Readiness date"
                disabled={disabled}
                disablePast={index >= originalBatchCount}
                inputProps={{ placeholder: "dd-mm-yyyy" }}
                dateStyle={{ width: "100%" }}
                minDate={
                  hasPreDoId && index < originalBatchCount ? today : undefined
                }
                maxDate={
                  hasPreDoId && index < originalBatchCount
                    ? maxAllowedDate
                    : undefined
                }
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={1.5}>
          <Controller
            name={`fgBatches.${index}.sellerOrderRef`}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Seller Order Ref"
                disabled={disabled}
                sx={inputFieldSx}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={1.5}>
          <Controller
            name={`fgBatches.${index}.sellerOLRef`}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Seller OL Ref"
                disabled={disabled}
                sx={inputFieldSx}
              />
            )}
          />
        </Grid>

        {children}
      </Grid>
    </Box>
  );
};

FGBatchRow.propTypes = {
  control: PropTypes.object,
  index: PropTypes.number,
  disabled: PropTypes.bool,
  disableFgReadyNow: PropTypes.bool,
  remainingQty: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isLastRow: PropTypes.bool,
  originalBatchCount: PropTypes.number,
  hasPreDoId: PropTypes.bool,
  today: PropTypes.instanceOf(Date),
  maxAllowedDate: PropTypes.instanceOf(Date),
  handleKeyDown: PropTypes.func,
  children: PropTypes.node,
};

export default FGBatchRow;
